import React, { HTMLAttributes } from 'react';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  variant?: 'default' | 'glass' | 'outline';
  hover?: boolean;
  clickable?: boolean;
}

const Card: React.FC<CardProps> = ({
  children,
  variant = 'default',
  hover = false,
  clickable = false,
  className = '',
  ...props
}) => {
  const baseClasses = 'rounded-2xl p-6 transition-all duration-200';
  
  const variantClasses = {
    default: 'bg-card',
    glass: 'glass-card',
    outline: 'border border-border bg-foreground/30',
  };
  
  const hoverClass = hover ? 'hover:shadow-lg hover:shadow-primary/5 hover:-translate-y-1' : '';
  const clickableClass = clickable ? 'cursor-pointer active:scale-98' : '';
  
  return (
    <div
      className={`${baseClasses} ${variantClasses[variant]} ${hoverClass} ${clickableClass} ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};

export default Card; 